import { createContext, useEffect, useState, useTransition } from 'react'
import { useHistoryCustomBack } from 'weblite-router'
import { useDebounce } from '$common/react-hooks/use-debounce'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackSearch } from '$common/app-bar/app-bar-back-search'
import { closeRoomListSearch } from '$logic/router'
import { ChatListSearched } from './chat-list-searched'
import { RecentUsers } from './components/recent-users'
import { LastSearchedChats } from './components/last-searched-chats'

export const SearchQueryContext = createContext('')

export function ChatListSearch() {
  const [, startTransition] = useTransition()
  const [searchQuery, setSearchQuery] = useState('')
  const [delayedQuery, setDelayedQuery] = useState('')
  const debouncedQuery = useDebounce(delayedQuery, 1000)

  useEffect(() => {
    analite('CHATLIST_SEARCH_CONTENT', { content: debouncedQuery })
  }, [debouncedQuery])
  useHistoryCustomBack(() => {
    closeRoomListSearch()
  }, [])

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackSearch
          onBack={closeRoomListSearch}
          setQuery={q => {
            setSearchQuery(q)
            startTransition(() => setDelayedQuery(q))
          }}
          value={searchQuery}
        />
      }
    >
      {debouncedQuery ? (
        <SearchQueryContext.Provider value={debouncedQuery}>
          <ChatListSearched query={debouncedQuery} />
        </SearchQueryContext.Provider>
      ) : (
        <div style={{ height: '100%', overflow: 'auto' }}>
          <RecentUsers />
          <LastSearchedChats />
        </div>
      )}
    </PageWithAppBar>
  )
}
